var _a;
// Types
import { Sizes } from '../../../common/types/Sizes';
export var TooltipStylePropertiesBySize = (_a = {},
    _a[Sizes.LARGE] = {
        maxWidth: '600px',
        padding: '12px',
    },
    _a[Sizes.MEDIUM] = {
        maxWidth: '400px',
        padding: '12px',
    },
    _a[Sizes.SMALL] = {
        maxWidth: '200px',
        padding: '12px',
    },
    _a[Sizes.X_SMALL] = {
        maxWidth: '200px',
        padding: '4px 12px',
    },
    _a);
//# sourceMappingURL=TooltipStylePropertiesBySize.js.map